export default ({ loginUrl, apiKey, query, env }) => {
  const isProd = env === 'prod' || env === 'preprod'

  const envLoginUrl = isProd
    ? loginUrl && loginUrl.prod
    : loginUrl && loginUrl.qa
  const envApiKey = isProd ? apiKey && apiKey.prod : apiKey && apiKey.qa

  if (envLoginUrl && envApiKey) {
    return `${envLoginUrl}${envApiKey}&${query}`
  }

  return null
}
